// Labels every team profile shares, Dutch: section titles, row labels, downloads, contact, PDF sections.
module.exports = {
  personal: {
    title: 'Persoonlijke gegevens',
    rows: {
      name: 'Naam',
      position: 'Functie',
      birthdate: 'Geboortedatum',
      nationality: 'Nationaliteit',
      maritalStatus: 'Burgerlijke staat',
      location: 'Standplaats',
      languages: 'Talen',
      programmingLanguages: 'Programmeertalen',
      certifications: 'Certificeringen',
      publications: 'Publicaties',
      links: 'Website'
    }
  },
  education: {
    title: 'Opleiding'
  },
  skills: {
    title: 'Specialistische vaardigheden'
  },
  experience: {
    title: 'Projecten en werkzaamheden',
    techLabel: 'Technologieën'
  },
  downloads: {
    title: 'Profiel downloaden',
    deLabel: 'Duitstalig profiel downloaden',
    deDescription: 'PDF in het Duits',
    enLabel: 'Engelstalig cv downloaden',
    enDescription: 'PDF in het Engels'
  },
  cta: {
    title: 'Contact',
    button: 'Contact opnemen'
  },
  pdf: {
    title: 'Profiel',
    personalSection: 'Persoonlijke gegevens',
    educationSection: 'Opleiding',
    experienceSection: 'Projecten en werkzaamheden',
    skillsLabel: 'Vaardigheden'
  }
};
